export var TypeOrder;
(function (TypeOrder) {
    TypeOrder["LOCAL"] = "LOCAL";
    TypeOrder["DELIVERY"] = "DELIVERY";
    TypeOrder["COLLECT"] = "COLLECT";
})(TypeOrder || (TypeOrder = {}));
export var MainView;
(function (MainView) {
    MainView["DIRECTORY"] = "DIRECTORY";
    MainView["MENU"] = "MENU";
    MainView["COMMAND"] = "COMMAND";
})(MainView || (MainView = {}));
export default {
    restaurant: null,
    menu: null,
    language: 'spanish',
    customLogoURL: '',
    customBackgroundURL: '',
    currency: '',
    categoryId: '',
    order: null,
    user: null,
    slug: undefined,
    typeOrder: TypeOrder.LOCAL,
    address: null,
    deliveryMenu: undefined,
    addressBook: undefined,
    mainView: undefined
};
